import axios from "@/axios.js"; // ✅ import ตรงนี้

export default {
    namespaced: true,
    state: {
        features: []
    },
    getters: {
        getFeatures: state => state.features
    },
    actions: {
        async loadFeatures({ commit }) {
            const resp = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/api/package/features`);
            commit("SET_FEATURES", resp.data.features);
        }
    },
    mutations: {
        SET_FEATURES(state, features) {
            state.features = features;
        }
    }
};
